<div class="p-2 w-100">
  
    <!-- Header minimalista -->
    <div class="uncp-header text-white p-4 mb-4">
        <div class="d-flex justify-content-between align-items-center">
        <div>
            <h3 class="mb-1 fw-light">
            <i class="fas fa-users me-2"></i>
            Administración de Usuarios
            </h3>
        </div>
        <button class="btn btn-light uncp-btn" data-bs-toggle="modal" data-bs-target="#modalAdd" (click)="resetForm()">
            <i class="fas fa-plus me-1"></i>
            Nuevo Usuario
        </button>
        </div>
    </div>

    <!-- Estadísticas rápidas -->
    <div class="card border-0 shadow-sm mb-4">
        <div class="card-body py-3">
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <i class="fas fa-chart-bar text-info fs-4 me-3"></i>
                    <div>
                        <h6 class="mb-0 fw-bold">Total de Usuarios</h6>
                        <span class="text-muted">Registrados en el sistema</span>
                    </div>
                </div>
                <span class="badge bg-info fs-5 px-3 py-2">{{pages[0]?.rows || 0}}</span>
            </div>
        </div>
    </div>

    <!-- Controles de búsqueda y filtros -->
    <div class="row mx-0 mb-3 align-items-center">
        <div class="col-md-6 px-1">
            <div class="input-group">
                <span class="input-group-text"><i class="fas fa-search"></i></span>
                <input type="text" class="form-control" placeholder="Buscar usuarios..." 
                    [(ngModel)]="searchTerm" (input)="paginar();">
            </div>
        </div>
        <div class="col-md-6 px-1 text-md-end mt-2 mt-md-0">
            <div class="d-flex align-items-center justify-content-md-end">
                <span class="me-2 small text-muted">Mostrar:</span>
                <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize" (change)="paginar();">
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </div>
        </div>
    </div>

    <!-- Tabla -->
    <div class="card uncp-card">
        <div class="table-responsive">
            <table class="table table-hover uncp-table mb-0">
                <thead>
                    <tr>
                        <th style="min-width: 15px;">#</th>
                        <th>Email</th>
                        <th class="d-none d-md-table-cell">Nombre</th>
                        <th>Último Acceso</th>
                        <th class="text-center">Privilegios</th>
                        <th class="text-center">Estado</th>
                        <th class="text-center" style="width: 120px;">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Loading -->
                    <tr *ngIf="!ready">
                        <td colspan="7" class="text-center py-4">
                        <div class="spinner-border text-uncp" role="status"></div>
                        <div class="mt-2">Cargando...</div>
                        </td>
                    </tr>
                    <!-- Sin resultados -->
                    <tr *ngIf="ready && usuarios.length === 0">
                        <td colspan="7" class="text-center py-4 text-muted">
                            No se encontraron usuarios
                        </td>
                    </tr>
                    <!-- Datos -->
                    <tr *ngFor="let p of usuarios; let i = index">
                        <td class="text-muted small">{{(pageActive-1)*pageSize+i+1}}</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-user-circle text-uncp me-2 fa-lg"></i>
                                <div>
                                <div class="fw-medium">{{p.t1_email}}</div>
                                <small class="text-muted d-md-none">{{p.t1_name}}</small>
                                </div>
                            </div>
                        </td>
                        <td class="d-none d-md-table-cell">{{p.t1_name}}</td>
                        <td>
                            <p class="text-muted m-0 lh-1" *ngIf="p.t1_ultimo_acceso">
                                <small>
                                    <i class="fas fa-calendar-alt me-1"></i>
                                    {{p.t1_ultimo_acceso | date:'dd/MM/yyyy'}}
                                    <br>
                                    <i class="fas fa-clock me-1"></i>
                                    {{p.t1_ultimo_acceso | date:'HH:mm:ss'}}
                                </small>
                            </p>
                        </td>
                        <td class="text-center">
                            <span class="badge" [ngClass]="{
                                'bg-secondary': p.t1_privilegios === 0,
                                'bg-primary': p.t1_privilegios === 1
                            }">
                                {{p.t1_privilegios === 0 ? 'Usuario' : 'Admin'}}
                            </span>
                        </td>
                        <td class="text-center">
                            <span class="badge" [ngClass]="{
                                'bg-success': p.t1_estado,
                                'bg-danger': !p.t1_estado
                            }">
                                {{p.t1_estado ? 'Activo' : 'Inactivo'}}
                            </span>
                        </td>
                        <td class="text-center">
                            <div class="btn-group btn-group-sm">
                                <button class="btn btn-outline-primary" (click)="edit(p)" title="Editar" data-bs-toggle="modal" data-bs-target="#modalAdd">
                                <i class="fas fa-edit"></i>
                                </button>
                                <button class="btn btn-outline-danger" (click)="eliminar(p)" title="Eliminar" data-bs-toggle="modal" data-bs-target="#modalEliminar">
                                <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="pages && pages.length > 0">
        <div class="text-muted small">
            Mostrando {{(pageActive-1)*pageSize + 1}} de {{pages[0]?.rows || 0}}
        </div>
        <nav>
            <ul class="pagination pagination-sm mb-0">
                <li class="page-item" [ngClass]="{'disabled': pageActive === 1}">
                <a class="page-link" (click)="getData(1)" style="cursor:pointer;">
                    <i class="fas fa-angle-double-left"></i>
                </a>
                </li>
                <li class="page-item" [ngClass]="{'disabled': pageActive === 1}">
                <a class="page-link" (click)="getData(pageActive - 1)" style="cursor:pointer;">
                    <i class="fas fa-chevron-left"></i>
                </a>
                </li>
                <li *ngFor="let page of pages" class="page-item" 
                    [ngClass]="{
                    'active': pageActive == page.pagina, 
                    'd-none': (page.pagina > (pageActive + 2)) || (page.pagina < (pageActive - 2))
                    }">
                <a class="page-link" (click)="getData(page.pagina)" style="cursor:pointer;">
                    {{page.pagina}}
                </a>
                </li>
                <li class="page-item" [ngClass]="{'disabled': pageActive === pages.length}">
                <a class="page-link" (click)="getData(pageActive + 1)" style="cursor:pointer;">
                    <i class="fas fa-chevron-right"></i>
                </a>
                </li>
                <li class="page-item" [ngClass]="{'disabled': pageActive === pages.length}">
                <a class="page-link" (click)="getData(pages.length)" style="cursor:pointer;">
                    <i class="fas fa-angle-double-right"></i>
                </a>
                </li>
            </ul>
        </nav>
    </div>

</div>






<!-- Modal Crear/Editar -->
<div class="modal fade" id="modalAdd" tabindex="-1" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-uncp text-white">
                <h5 class="modal-title">
                <i class="fas fa-user-edit me-2"></i>
                {{ !usuario.t1_id ? 'Nuevo Usuario' : 'Editar Usuario' }}
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" (click)="resetForm()"></button>
            </div>
            
            <form #proyectoForm="ngForm" (ngSubmit)="submit()" novalidate>
                <div class="modal-body p-4">
                    <!-- Email -->
                    <div class="mb-3">
                        <label class="form-label">Email <span class="text-danger">*</span></label>
                        <input type="email" class="form-control" placeholder="usuario@uncp.edu.pe"
                            [(ngModel)]="usuario.t1_email" name="t1_email" required>
                    </div>
                    
                    <!-- Nombre -->
                    <div class="mb-3">
                        <label class="form-label">Nombre Completo</label>
                        <input type="text" class="form-control" placeholder="Nombre completo"
                            [(ngModel)]="usuario.t1_name" name="t1_name" required>
                    </div>
                    
                    <!-- Privilegios -->
                    <div class="mb-3">
                        <label class="form-label">Privilegios <span class="text-danger">*</span></label>
                        <select class="form-select" [(ngModel)]="usuario.t1_privilegios" name="t1_privilegios" required>
                            <option value="null" disabled>Seleccionar</option>
                            <option value="0">Usuario</option>
                            <option value="1">Administrador</option>
                        </select>
                    </div>
                    
                    <!-- Estado -->
                    <div class="mb-3">
                        <label class="form-label">Estado <span class="text-danger">*</span></label>
                        <select class="form-select" [(ngModel)]="usuario.t1_estado" name="t1_estado" required>
                            <option value="null" disabled>Seleccionar</option>
                            <option value="1">Activo</option>
                            <option value="0">Inactivo</option>
                        </select>
                    </div>
                    
                    <!-- Info adicional -->
                    <div *ngIf="usuario.t1_id" class="alert alert-light">
                        <small class="text-muted">
                        <i class="fas fa-info-circle me-1"></i>
                        ID: {{usuario.t1_id}}
                        </small>
                    </div>
                </div>
                
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="resetForm()" [disabled]="!btn">
                        Cancelar
                    </button>
                    <button type="submit" class="btn btn-primary" [disabled]="!btn || !proyectoForm.form.valid">
                        <span *ngIf="!btn" class="spinner-border spinner-border-sm me-1"></span>
                        {{ !usuario.t1_id ? 'Crear' : 'Actualizar' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Modal Eliminar -->
<div class="modal fade" id="modalEliminar" data-bs-backdrop="static" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header bg-danger text-white">
                <h6 class="modal-title">
                <i class="fas fa-trash me-2"></i>
                Confirmar Eliminación
                </h6>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" (click)="resetForm();"></button>
            </div>
            <div class="modal-body">
                <div class="text-center">
                <i class="fas fa-exclamation-triangle text-warning fa-2x mb-3"></i>
                <p>¿Eliminar el usuario <strong>{{usuario.t1_email}}</strong>?</p>
                <small class="text-muted">Esta acción no se puede deshacer.</small>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="resetForm();" [disabled]="!btn">
                Cancelar
                </button>
                <button *ngIf="btn" type="button" class="btn btn-danger" (click)="eliminar({})">
                Eliminar
                </button>
                <button *ngIf="!btn" type="button" class="btn btn-danger" disabled>
                <span class="spinner-border spinner-border-sm me-1"></span>
                Eliminando...
                </button>
            </div>
        </div>
    </div>
</div>